const mapper_options = {
  endpoint: 'reporting/pulse/campaign_impressions',
  recordClass: require('./record'),
  relations: {
    belongsTo: {
      brand: {
        foreignKey: 'brand_id',
        localField: 'brand'
      }
    }
  }
}

module.exports = (store) => {
  store.defineMapper('campaign_impressions', mapper_options)
}
